import {Grid, GridItem, Show, VStack} from 'platform/foundation';

import {EntityResourceIds} from '@dms/api/shared';
import {testIds} from '@dms/routes';
import {
  CommentsWidget,
  EntityCustomFields,
  NoteWidget,
  Section,
  useWorkshopInterestEditPermissions,
} from '@dms/shared';

type OverviewProps = {
  interestId: string;
};

export function Overview(props: OverviewProps) {
  const {
    hasSetNotePermission,
    hasEditCustomFieldsPermission,
    hasReadCustomFieldsPermission,
    hasReadCommentsPermission,
    hasAddCommentPermission,
    hasUpdateCommentPermission,
    hasDeleteCommentPermission,
  } = useWorkshopInterestEditPermissions({interestId: props.interestId});

  return (
    <Section>
      <Grid columns={2}>
        <GridItem span={1}>
          <VStack spacing={4}>
            <Show when={hasReadCustomFieldsPermission}>
              <EntityCustomFields
                recordId={props.interestId}
                resourceId={EntityResourceIds.workshopInterest}
                isEditable={hasEditCustomFieldsPermission}
                data-testid={testIds.workshop.interestDetail('workshop-interest-custom-fields')}
              />
            </Show>
            <Show when={hasReadCommentsPermission}>
              <CommentsWidget
                resourceId={EntityResourceIds.workshopInterest}
                recordId={props.interestId}
                isAddDisabled={!hasAddCommentPermission}
                isEditDisabled={!hasUpdateCommentPermission}
                isDeleteDisabled={!hasDeleteCommentPermission}
                data-testid={testIds.workshop.interestDetail('comments')}
              />
            </Show>
          </VStack>
        </GridItem>
        <GridItem span={1}>
          <NoteWidget
            isEditable={hasSetNotePermission}
            resourceId={EntityResourceIds.workshopInterest}
            recordId={props.interestId}
            context={EntityResourceIds.workshopInterest}
            data-testid={testIds.workshop.interestDetail('note')}
          />
        </GridItem>
      </Grid>
    </Section>
  );
}
